import styled from 'styled-components';
import { Heading3Text } from '../../components/Texts';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TabGroup from '../../components/TabGroup';
import Report from './Report';
import ListBuilder from './ListBuilder';
import CheckStatus from './CheckStatus';
import BridgeCardsTest from './BridgeCardsTest';
import BulkOrder from './BulkOrder';
import ServerWallets from './ServerWallets';
import DiscountCode from './DiscountCode';
import BulkNotification from './BulkNotification';
import OnrampTransactions from './OnrampTransactions';
import { selectPrivyToken } from '../../redux/slices/auth';
import { useSelector } from 'react-redux';
import { useGetCurrentUserProfileQuery } from '../../redux/api/authorized/auth';

const Container = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  gap: 20px;
`;

const Admin = () => {
  const [activeTab, setActiveTab] = useState('REPORT');
  const navigate = useNavigate();

  const privyToken = useSelector(selectPrivyToken);
  const { data: currentUser } = useGetCurrentUserProfileQuery(undefined, {
    skip: !privyToken,
  });

  useEffect(() => {
    if (currentUser && currentUser.role !== 'ADMIN') {
      navigate('/');
    }
  }, [currentUser, navigate]);

  const tabs = [
    {
      label: 'Report',
      value: 'REPORT',
    },
    {
      label: 'List Builder',
      value: 'LIST_BUILDER',
    },
    {
      label: 'Check Status',
      value: 'CHECK_STATUS',
    },
    {
      label: 'Bridge Cards Test',
      value: 'BRIDGE_CARDS_TEST',
    },
    {
      label: 'Server Wallets',
      value: 'SERVER_WALLETS',
    },
    {
      label: 'Bulk Order',
      value: 'BULK_ORDER',
    },
    {
      label: 'Discount Code',
      value: 'DISCOUNT_CODE',
    },
    {
      label: 'Bulk Notification',
      value: 'BULK_NOTIFICATION',
    },
    {
      label: 'Onramp Transactions',
      value: 'ONRAMP_TRANSACTIONS',
    },
  ];

  return (
    <Container>
      <Heading3Text>Admin</Heading3Text>
      <TabGroup tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      {activeTab === 'REPORT' && <Report />}
      {activeTab === 'LIST_BUILDER' && <ListBuilder />}
      {activeTab === 'CHECK_STATUS' && <CheckStatus />}
      {activeTab === 'BRIDGE_CARDS_TEST' && <BridgeCardsTest />}
      {activeTab === 'SERVER_WALLETS' && <ServerWallets />}
      {activeTab === 'BULK_ORDER' && <BulkOrder />}
      {activeTab === 'DISCOUNT_CODE' && <DiscountCode />}
      {activeTab === 'BULK_NOTIFICATION' && <BulkNotification />}
      {activeTab === 'ONRAMP_TRANSACTIONS' && <OnrampTransactions />}
    </Container>
  );
};

export default Admin;
